<template>
    <span>
        <svg-icon :width="width" :height="height" :viewBox="`0 0 ${height} ${width}`" iconName="topup">
            <defs>
                <path id="s0mk5e78ea" d="M12 4c2.137 0 4.146.832 5.657 2.343C19.167 7.854 20 9.863 20 12s-.832 4.146-2.343 5.657C16.146 19.167 14.137 20 12 20s-4.146-.832-5.657-2.343C4.833 16.146 4 14.137 4 12s.832-4.146 2.343-5.657C7.854 4.833 9.863 4 12 4zm0 1.293c-3.698 0-6.707 3.009-6.707 6.707S8.302 18.707 12 18.707s6.707-3.009 6.707-6.707S15.698 5.293 12 5.293zm1.052 2.075c.076.061.147.13.21.203l2.357 2.73c.435.504.504 1.214.174 1.787l-2.357 4.096c-.44.766-1.44 1.042-2.234.616-.268-.144-.49-.357-.638-.616l-2.357-4.096c-.33-.573-.26-1.283.174-1.786l2.357-2.731c.58-.673 1.617-.764 2.314-.203zm-1.334.754L9.085 11.05c-.097.108-.112.26-.039.383l2.633 4.392c.033.055.083.101.143.132.177.091.4.032.499-.132l2.633-4.392c.073-.123.058-.275-.04-.383l-2.632-2.928c-.014-.015-.03-.03-.047-.043-.156-.12-.387-.1-.517.043z"/>
            </defs>
            <g fill="none" fill-rule="evenodd">
                <mask id="kqp97rg5yb" fill="#fff">
                    <use xlink:href="#s0mk5e78ea"/>
                </mask>
                <g class="path" :fill="fill" mask="url(#kqp97rg5yb)">
                    <path :d="`M0 0H${height}V${width}H0z`"/>
                </g>
            </g>
        </svg-icon>
    </span>
</template>

<script>
import SvgIcon from '@theme-views/common/SvgIcon'

export default {
    name: 'svg-topup',
    computed: {
        fill() {
            return this.color || 'url(#linearGradient-1)'
        }
    },
    components: {
        SvgIcon
    },
    props: {
        width: {
            type: Number,
            default: 26,
        },
        height: {
            type: Number,
            default: 26,
        },
        color: {
            type: String,
            default: null
        }
    },
}
</script>